import axios from "@/services/base.service";
import { AxiosResponse } from "axios";
import { TermsAndConditionsBlock } from "@/interfaces/terms-and-conditions.interface";

export interface AcceptTermsResponse {
  terms_and_conditions: TermsAndConditionsBlock;
  // Soporta wrapper Laravel Resource: { data: { terms_and_conditions: ... } }
  data?: {
    terms_and_conditions: TermsAndConditionsBlock;
  };
}

export const acceptTerms = async (
  basePath: string,
  eventId: number
): Promise<AxiosResponse<AcceptTermsResponse>> => {
  return await axios.post<AcceptTermsResponse>(
    "/terms-and-conditions/accept",
    { event_id: eventId },
    {
      headers: {
        "X-Source": "web",
        "X-Base-Path": basePath,
        "X-Event-Id": String(eventId),
      },
    }
  );
};

export interface TermsContentResponse {
  html: string;
}

// Visor TyC: backend proxy opcional (si existe) para poder medir scroll en same-origin
export const getTermsContent = async (
  url: string
): Promise<AxiosResponse<TermsContentResponse>> => {
  return await axios.get<TermsContentResponse>("/terms-and-conditions/content", {
    params: { url },
  });
};





